/**
 * Parses a PathFollow2D: the Node2D surface plus the follow controls, whose
 * booleans default to Godot's true. `progress` and `progress_ratio` stay
 * undefined when unset, so a bad value is reported, not read as 0.
 */
import { parseNode2D } from '../../base/node2d/parser';
import { floatOr, boolOr } from '../../../parser/valueParsers';
export function parsePathFollow2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    const result = {
        ...base,
        h_offset: floatOr(properties.h_offset, 0),
        v_offset: floatOr(properties.v_offset, 0),
        rotates: boolOr(properties.rotates, true),
        cubic_interp: boolOr(properties.cubic_interp, true),
        loop: boolOr(properties.loop, true),
    };
    if (properties.progress !== undefined)
        result.progress = floatOr(properties.progress, 0);
    if (properties.progress_ratio !== undefined) {
        result.progress_ratio = floatOr(properties.progress_ratio, 0);
    }
    return result;
}
//# sourceMappingURL=parser.js.map